import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
})
export class NotFoundComponent implements OnInit {
  requestedPath = '';
  isAuthenticated = false;

  constructor(
    private router: Router,
    private location: Location,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.requestedPath = this.router.url || '';
    this.isAuthenticated = this.authService.isAuthenticated;
  }

  get canShowRequestedPath(): boolean {
    return !!this.requestedPath && this.requestedPath !== '/not-found';
  }

  goBack(): void {
    if (window.history.length > 1) {
      this.location.back();
      return;
    }
    this.goToDefault();
  }

  goToDefault(): void {
    if (this.isAuthenticated) {
      this.router.navigateByUrl('/dashboard/statistics');
      return;
    }
    this.router.navigateByUrl('/auth/signin');
  }

  reloadPage(): void {
    window.location.reload();
  }
}
